export default {
  path: '/robot/bot',
  title: ' 社群管家',
  icon: 'comments',
  hideSub: true,
  children: (pre => [
    // {
    //   title: '概览',
    //   icon: 'dashboard',
    //   path: `${pre}index`
    // },
    {
      title: '机器人管理',
      icon: 'android',
      path: `${pre}bot`
    },
    {
      title: '群聊管理',
      icon: 'comments',
      path: `${pre}groupchat`,
      children: [
        {
          title: '群分组设置',
          icon: 'circle',
          path: `${pre}groupchat`
        },
        {
          title: '管理员设置',
          icon: 'circle',
          path: `${pre}groupchat/admin`
        }
      ]
    },
    {
      title: '入群欢迎',
      icon: 'graduation-cap',
      path: `${pre}welcome`
    },
    {
      title: '自动回复',
      icon: 'mail-reply-all',
      path: `${pre}autoreply`
    },
    {
      title: '朋友圈管理',
      icon: 'circle',
      path: `${pre}circle`
    },
    {
      title: '消息群发',
      icon: 'paper-plane',
      path: `${pre}batchmsg`,
      children: [
        {
          title: '消息群发',
          icon: false,
          path: `${pre}batchmsg/send`
        },
        {
          title: '发送记录',
          icon: false,
          path: `${pre}batchmsg/index`
        }
      ]
    },
    {
      title: '自动邀请',
      icon: 'share-alt',
      path: `${pre}invite`
    },
    // {
    //   title: '自动加人',
    //   icon: 'user',
    //   path: `${pre}add`
    // },
    {
      title: '群公告',
      icon: 'volume-up',
      path: `${pre}notice`,
      children: [
        {
          title: '发布公告',
          icon: 'circle',
          path: `${pre}notice/send`
        },
        {
          title: '历史公告',
          icon: 'circle',
          path: `${pre}notice`
        }
      ]
    },
    {
      title: '踢人设置',
      icon: 'gear',
      path: `${pre}kick`,
      children: [
        {
          title: '自动踢人',
          icon: 'circle',
          path: `${pre}kick`
        },
        {
          title: '黑名单',
          icon: 'circle',
          path: `${pre}kick/blacklist`
        }
      ]
    }
  ])('/robot/')
}
